import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./features/Store";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "../src/constants/config/authConfig";
import "./constants/languages/configLang";

(async () => {
  await msalInstance.initialize();
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
          <App />
        </Provider>
      </MsalProvider>
    </React.StrictMode>
  );
})();
